/**
 * @fileoverview Agent definition for the story-dna-extractor-v2 primitive.
 *
 * This agent extracts the core "DNA" of a story - fundamental architectural
 * components like plot type, POV, genre, and setting from unstructured text.
 *
 * @category import.story.extraction
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'story-dna-extractor-v2',
  kind: 'primitive',
  name: 'Story DNA Extractor',
  description: 'Analyzes a document to extract core architectural components like plot type, POV, and genre.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2025-01',
    taxonomyPath: 'import.story.extraction',
    usedBy: ['ImportStoryDialog', 'use-import-story.ts'],
    relatedAgents: ['plot-extractor-v2', 'chapter-extractor-v2', 'genre-detector-v2'],
  },
};
